module.exports = function (done, value) {
  return { value: value, done: !!done };
};



//////////////////
// WEBPACK FOOTER
// /Users/cully/projects/Jobs/abound/~/core-js/modules/_iter-step.js
// module id = ../../node_modules/core-js/modules/_iter-step.js
// module chunks = 18